import Types from '../types/incidentReport';

const initialState = {
  programs: {
    loading: false,
    data: [],
    error: '',
  },
  ddps: {
    loading: false,
    data: [],
    error: '',
  },
  participants: {
    loading: false,
    data: [],
    error: '',
  },
  newIRs: {
    loading: false,
    data: {},
    error: '',
  },
  qaIRs: {
    loading: false,
    data: [],
    error: '',
  },
  resolvedIRs: {
    loading: false,
    data: [],
    error: '',
  },
  participantIRs: {
    loading: false,
    data: {},
    error: '',
  },
  employeeIRs: {
    loading: false,
    data: {},
    error: '',
  },
  incidentReport: {
    loading: false,
    data: {},
    error: '',
  },
};

export default function incidentReport(state = initialState, action) {
  switch (action.type) {
    case Types.GET_IR_PROGRAMS_REQUEST:
      return {
        ...state,
        programs: {
          ...state.programs,
          loading: true,
        },
      };
    case Types.GET_IR_PROGRAMS_SUCCESS:
      return {
        ...state,
        programs: {
          error: '',
          loading: false,
          data: action.data,
        },
      };
    case Types.GET_IR_PROGRAMS_ERROR:
      return {
        ...state,
        programs: {
          loading: false,
          error: action.payload,
          data: [],
        },
      };
    case Types.GET_IR_DDPS_REQUEST:
      return {
        ...state,
        ddps: {
          ...state.ddps,
          data: [],
          loading: true,
        },
      };
    case Types.GET_IR_DDPS_SUCCESS:
      return {
        ...state,
        ddps: {
          error: '',
          loading: false,
          data: action.data,
        },
      };
    case Types.GET_IR_DDPS_ERROR:
      return {
        ...state,
        ddps: {
          loading: false,
          error: action.payload,
          data: [],
        },
      };
    case Types.GET_IR_PARTICIPANTS_REQUEST:
      return {
        ...state,
        participants: {
          ...state.participants,
          data: [],
          loading: true,
        },
      };
    case Types.GET_IR_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        participants: {
          error: '',
          loading: false,
          data: action.data,
        },
      };
    case Types.GET_IR_PARTICIPANTS_ERROR:
      return {
        ...state,
        participants: {
          loading: false,
          error: action.payload,
          data: [],
        },
      };
    case Types.GET_NEW_INCIDENT_REPORTS_REQUEST:
      return {
        ...state,
        newIRs: {
          ...state.newIRs,
          loading: true,
        },
      };
    case Types.GET_NEW_INCIDENT_REPORTS_SUCCESS:
      return {
        ...state,
        newIRs: {
          error: '',
          loading: false,
          data: action.data,
        },
      };
    case Types.GET_NEW_INCIDENT_REPORTS_ERROR:
      return {
        ...state,
        newIRs: {
          loading: false,
          error: action.payload,
          data: {},
        },
      };
    case Types.GET_QA_INCIDENT_REPORTS_REQUEST:
      return {
        ...state,
        qaIRs: {
          ...state.qaIRs,
          loading: true,
        },
      };
    case Types.GET_QA_INCIDENT_REPORTS_SUCCESS:
      return {
        ...state,
        qaIRs: {
          error: '',
          loading: false,
          data: action.data,
        },
      };
    case Types.GET_QA_INCIDENT_REPORTS_ERROR:
      return {
        ...state,
        qaIRs: {
          loading: false,
          error: action.payload,
          data: [],
        },
      };
    case Types.GET_RESOLVED_INCIDENT_REPORTS_REQUEST:
      return {
        ...state,
        resolvedIRs: {
          ...state.resolvedIRs,
          loading: true,
        },
      };
    case Types.GET_RESOLVED_INCIDENT_REPORTS_SUCCESS:
      return {
        ...state,
        resolvedIRs: {
          error: '',
          loading: false,
          data: action.data,
        },
      };
    case Types.GET_RESOLVED_INCIDENT_REPORTS_ERROR:
      return {
        ...state,
        resolvedIRs: {
          loading: false,
          error: action.payload,
          data: [],
        },
      };
    case Types.GET_PARTICIPANT_IRS_REQUEST:
      return {
        ...state,
        participantIRs: {
          ...state.participantIRs,
          loading: true,
        },
      };
    case Types.GET_PARTICIPANT_IRS_SUCCESS:
      return {
        ...state,
        participantIRs: {
          error: '',
          loading: false,
          data: action.data,
        },
      };
    case Types.GET_PARTICIPANT_IRS_ERROR:
      return {
        ...state,
        participantIRs: {
          loading: false,
          error: action.payload,
          data: {},
        },
      };
    case Types.GET_EMPLOYEE_IRS_REQUEST:
      return {
        ...state,
        employeeIRs: {
          ...state.employeeIRs,
          loading: true,
        },
      };
    case Types.GET_EMPLOYEE_IRS_SUCCESS:
      return {
        ...state,
        employeeIRs: {
          error: '',
          loading: false,
          data: action.data,
        },
      };
    case Types.GET_EMPLOYEE_IRS_ERROR:
      return {
        ...state,
        employeeIRs: {
          loading: false,
          error: action.payload,
          data: {},
        },
      };
    case Types.QA_INCIDENT_REPORT_REQUEST:
      return {
        ...state,
        incidentReport: {
          ...state.incidentReport,
          loading: true,
        },
      };
    case Types.QA_INCIDENT_REPORT_SUCCESS:
      return {
        ...state,
        incidentReport: {
          error: '',
          loading: false,
          data: action.data,
        },
      };
    case Types.QA_INCIDENT_REPORT_ERROR:
      return {
        ...state,
        incidentReport: {
          loading: false,
          error: action.payload,
          data: [],
        },
      };
    default:
      return state;
  }
}
